module.exports = __webpack_public_path__ + "assets/img/养老机构.db1541d7.png";